// Тема Naive UI поверх токенов дизайна (docs/10-design/tokens.md).
// Значения дублируют variables.sass намеренно: Sass-переменные недоступны в JS,
// а темизация Naive UI задаётся объектом. При правке токена править оба места.
// Что закрывается темой, а что переписывается своей вёрсткой —
// docs/10-design/naive-ui.md.

const BRAND = "#1c7a3b"
const BRAND_DARK = "#145e2d"
const BRAND_SOFT = "#e6f2ea"
const INK = "#131a17"
const INK_2 = "#566a61"
const MUTED = "#6e7f77"
const DISABLED = "#b4c2ba"
const LINE = "#e4eae6"
const LINE_HOVER = "#c9dbcf"
const BG = "#f4f7f5"
const SURFACE = "#ffffff"
const DANGER = "#c0392b"
const WARNING = "#a87a22"

const FONT_FAMILY = '"Golos Text", system-ui, -apple-system, sans-serif'

export const naiveThemeOverrides = {
  common: {
    fontFamily: FONT_FAMILY,
    fontWeightStrong: "600",

    primaryColor: BRAND,
    primaryColorHover: BRAND_DARK,
    primaryColorPressed: BRAND_DARK,
    primaryColorSuppl: BRAND_DARK,

    infoColor: BRAND,
    infoColorHover: BRAND_DARK,
    infoColorPressed: BRAND_DARK,
    infoColorSuppl: BRAND_DARK,

    successColor: BRAND,
    successColorHover: BRAND_DARK,
    successColorPressed: BRAND_DARK,
    successColorSuppl: BRAND_DARK,

    warningColor: WARNING,
    warningColorHover: WARNING,
    warningColorPressed: WARNING,
    warningColorSuppl: WARNING,

    errorColor: DANGER,
    errorColorHover: DANGER,
    errorColorPressed: DANGER,
    errorColorSuppl: DANGER,

    textColorBase: INK,
    textColor1: INK,
    textColor2: INK_2,
    textColor3: MUTED,
    textColorDisabled: DISABLED,
    placeholderColor: DISABLED,
    placeholderColorDisabled: DISABLED,
    iconColor: MUTED,
    iconColorHover: BRAND,
    iconColorPressed: BRAND_DARK,

    bodyColor: BG,
    cardColor: SURFACE,
    modalColor: SURFACE,
    popoverColor: SURFACE,
    tableColor: SURFACE,
    inputColor: SURFACE,
    actionColor: BG,
    hoverColor: BRAND_SOFT,

    borderColor: LINE,
    dividerColor: LINE,
    borderRadius: "10px",
    borderRadiusSmall: "8px",

    heightSmall: "32px",
    heightMedium: "40px",
    heightLarge: "44px",

    boxShadow1: "0 1px 2px rgba(19, 26, 23, 0.04)",
    boxShadow2: "0 18px 40px -20px rgba(19, 26, 23, 0.4)",
    boxShadow3: "0 32px 80px -32px rgba(19, 26, 23, 0.55)"
  },

  Input: {
    border: `1px solid ${LINE}`,
    borderHover: `1px solid ${LINE_HOVER}`,
    borderFocus: `1px solid ${BRAND}`,
    boxShadowFocus: "0 0 0 3px rgba(28, 122, 59, 0.12)",
    caretColor: BRAND
  },

  InternalSelection: {
    border: `1px solid ${LINE}`,
    borderHover: `1px solid ${LINE_HOVER}`,
    borderFocus: `1px solid ${BRAND}`,
    borderActive: `1px solid ${BRAND}`,
    boxShadowFocus: "0 0 0 3px rgba(28, 122, 59, 0.12)",
    boxShadowActive: "0 0 0 3px rgba(28, 122, 59, 0.12)"
  },

  Switch: {
    railColor: "#dce5df",
    railColorActive: BRAND,
    boxShadowFocus: "0 0 0 3px rgba(28, 122, 59, 0.12)"
  },

  Checkbox: {
    borderRadius: "6px",
    sizeMedium: "20px",
    borderChecked: `1px solid ${BRAND}`,
    colorChecked: BRAND,
    boxShadowFocus: "0 0 0 3px rgba(28, 122, 59, 0.12)"
  },

  Radio: {
    dotColorActive: BRAND,
    boxShadowFocus: `inset 0 0 0 1px ${BRAND}, 0 0 0 3px rgba(28, 122, 59, 0.12)`
  },

  Tabs: {
    tabTextColorActiveLine: BRAND,
    tabTextColorHoverLine: BRAND_DARK,
    barColor: BRAND
  },

  Popover: {
    borderRadius: "12px",
    color: SURFACE
  },

  Tooltip: {
    borderRadius: "8px"
  },

  Card: {
    borderRadius: "16px",
    borderColor: LINE
  },

  Alert: {
    borderRadius: "12px"
  },

  Badge: {
    color: DANGER
  },

  Spin: {
    color: BRAND
  }
}
